<template>
	<button
		:aria-disabled="processing || disabled" :class="classObject" :disabled="processing || disabled" class="button button--process"
		v-on="$listeners">
		<span v-if="!processing" v-html="$attrs.text"></span>
		<template v-else>
			<span v-html="processingText"/>
			<svg class="loader" stroke="#fff" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
				<g fill="none" fill-rule="evenodd">
					<g stroke-width="2" transform="translate(1 1)">
						<circle cx="18" cy="18" r="18" stroke-opacity=".5"/>
						<path d="M36 18c0-9.94-8.06-18-18-18">
							<animateTransform
								attributeName="transform"
								dur="1s"
								from="0 18 18"
								repeatCount="indefinite"
								to="360 18 18"
								type="rotate"/>
						</path>
					</g>
				</g>
			</svg>
		</template>
	</button>
</template>
<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			default() {
				return false;
			},
		},
		processing: {
			type: Boolean,
			default() {
				return false;
			},
		},
		processingText: {
			required: false,
			type: String,
			default() {
				return "Processing";
			},
		},
	},

	computed: {
		classObject() {
			return {
				processing: this.processing,
			};
		},
	},
};
</script>
